import { create } from 'zustand';

import type { SpeedOption } from '@/app/(main)/jogo/giro-da-sorte/[id]/_components/WheelSettingsDrawer/hooks/useWheelSettings';

type WheelSettingsState = {
  autoSpin: boolean;
  speed: SpeedOption;
  isMuted: boolean;
  setAutoSpin: (autoSpin: boolean) => void;
  setSpeed: (speed: SpeedOption) => void;
  setMuted: (isMuted: boolean) => void;
};

export const useWheelSettingsStore = create<WheelSettingsState>((set) => ({
  autoSpin: false,
  speed: 'normal',
  isMuted: false,
  setAutoSpin: (autoSpin: boolean) => set({ autoSpin }),
  setSpeed: (speed: SpeedOption) => set({ speed }),
  setMuted: (isMuted: boolean) => set({ isMuted }),
}));
